import { httpService } from './HttpService';
import { Log } from '../model/Log';


export class LogService {
    private _app: string = "";
    private _user: string = "";
    private _delay: number = 10000;
    private list: Array<any> = [];

    constructor(){
        this.InitSaveBuffer()
    }

    Debug(message: string, method: string = "", parameters: any = null){
        console.debug(method + " " + message);
        this.Save(message, method, parameters, "Debug");
    }

    Info(message: string, method: string = "", parameters: any = null){
        console.log(method + " " + message);
        this.Save(message, method, parameters, "Info");
    }

    Warn(message: string, method: string = "", parameters: any = null){
        console.warn(method + " " + message);
        this.Save(message, method, parameters, "Warn");
    }

    Error(message: string, method: string = "", parameters: any = null, error: any){
        console.error(method + " " + message+"\n"+JSON.stringify(error));
        this.Save(message+"\n"+JSON.stringify(error), method, parameters, "Error");
    }

    Fatal(message: string, method: string = "", parameters: any = null, error: any){
        console.error(method + " " + message+"\n"+JSON.stringify(error));
        this.Save(message+"\n"+JSON.stringify(error), method, parameters, "Fatal");
    }

    Save(message: string, method: string, parameters: any, level: string) {
        let log = new Log();
        log.App = "Frontend - "+this.app;
        log.Metodo = method;
        log.Mensaje = message;
        log.Usuario = this.user;
        log.Nivel = level;
        log.Params = parameters !== null ? JSON.stringify(parameters) : "";
        
        this.list.push(log);
    }

    InitSaveBuffer(){
        setInterval(()=>{
            let length = this.list.length;
            if(length > 0){
                let enviar: any = [];

                for (let i = 0; i < length; i++) {
                    enviar.push(this.list.shift());
                }

                httpService.post("log/collection", enviar);
            }
            
        }, this.delay)
    }

    set app(valor: string) {
        this._app = valor;
    }

    get app() {
        return this._app;
    }

    set user(valor: string) {
        this._user = valor;
    }

    get user() {
        return this._user;
    }

    set delay(valor: number) {
        this._delay = valor;
    }

    get delay() {
        return this._delay;
    }
}

export const logService = new LogService();